/**
 * Item selection toggle modes
 */
export const ToggleModes = {
  /** Both deselect and select */
  DEFAULT: '',

  /** Only deselect */
  DESELECT_ONLY: 'deselectOnly',

  /** Only select */
  SELECT_ONLY: 'selectOnly',
}
